export class FederatedGlueConnection {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "awsAccountId",
            "baseName": "awsAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "scope",
            "baseName": "scope",
            "type": "GlueSyncScope",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return FederatedGlueConnection.attributeTypeMap;
    }
    constructor() {
    }
}
